import { render, staticRenderFns } from "./IconTimeAlert.vue?vue&type=template&id=f2e42ee6"
import script from "./IconTimeAlert.vue?vue&type=script&lang=js"
export * from "./IconTimeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports